/*
 * Monospace formatting in the Editor "More Menu"
 */
import window from 'window-or-global';

export default function confMonoSpace() {
	const plugger = () => {
		return {
			init: (ed /*url*/) => {
				// Register commands
				ed.addCommand('confMonospace', () => {
					ed.formatter.toggle('monospace', undefined);
				});

				window.tinymce.activeEditor.on('Init', () => {
					const ed = window.tinymce.activeEditor;

					ed.formatter.register({ monospace: { inline: 'code' } });

					ed.editorCommands.addCommands(
						{
							confMonospace() {
								return ed.formatter.match('monospace');
							},
						},
						'state',
					);
				});

				// Register button
				ed.addButton('monospace', { title: 'monospace', cmd: 'confMonospace' });
			},

			getInfo: () => {
				return {
					longname: 'Monospace Formatting',
					author: 'Atlassian',
					authorurl: 'http://www.atlassian.com',
					version: `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}`,
				};
			},
		};
	};

	window.tinymce.create('tinymce.plugins.ConfMonospacePlugin', plugger());
	window.tinymce.PluginManager.add('confmonospace', window.tinymce.plugins.ConfMonospacePlugin);
}
